// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'
import VueFilter from 'vue-filter'
import Vue2Filters from 'vue2-filters'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router/router'
import store from './store/store'

import 'font-awesome/css/font-awesome.min.css'
import parseMenu from '@/utils/MenuUtil'
import VueI18n from 'vue-i18n'
import VueResource from 'vue-resource';

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(Vue2Filters)
Vue.use(VueFilter)
Vue.use(VueI18n)// 通过插件的形式挂载
Vue.use(VueResource)

//这里是防止用户手动刷新页面，整个app要重新加载,动态新增的路由，会消失，所以我们重新add一次
let staff = JSON.parse(window.sessionStorage.getItem('staff'))
if (staff){
  // console.log("Main refresh menus:",staff.menus);
  let routes = []
  parseMenu(routes,staff.menus)
  router.addRoutes(routes)
  router.options.routes.push(...routes);

  //更新VUX的staff，所有請求都是从vux.staff里取Token
  store.commit("updateStaff",staff);
}

//没登录就跳转到登录
router.beforeEach((to, from, next) => {
    //console.log("beforeEach");
    let staff = JSON.parse(window.sessionStorage.getItem('staff'));
    if (!staff && to.path !== '/login') {
      next({ path: '/login' })
    }else {
      next();
    }
})

const i18n = new VueI18n({
    locale: 'zh-CN',    // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
        'zh-CN': require('./common/lang/zh'),   // 中文语言包
        'en-US': require('./common/lang/en'),    // 英文语言包
        'zh-TW': require('./common/lang/tw')    // 繁体语言包
    }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,  // 不要忘记
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js